import axios from 'axios';
import { API_ROUTES } from '../../constants/app';
import { csrf } from './uploadApi';

export const downloadAsset = (
  assetId: string,
  collectionId: string,
): Promise<NewDownloadResponse> => {
  const params = new URLSearchParams();
  params.append('type', 'selection');
  params.append('iframe', 'false');
  params.append('includeArchive', 'true');
  params.append('collectionId', collectionId);
  params.append('addAdditionals', 'false');
  params.append('addWebversions', '@original');
  params.append('media_ids[]', assetId);

  return axios.post(API_ROUTES.ASSET_DOWNLOAD(), params, {
    headers: {
      'x-csrf-token': window.Bynder?.csrf_token ?? csrf,
      'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      'x-requested-with': 'XMLHttpRequest',
    },
  });
};

export const checkDownloadable = async (
  assetId: string,
): Promise<DownloadableCheck> => {
  const params = new URLSearchParams();
  params.append('id', assetId);
  return axios.post(API_ROUTES.CHECK_IS_ASSET_DOWNLOADABLE(), params, {
    headers: {
      'x-csrf-token': window.Bynder?.csrf_token ?? csrf,
      'content-type': 'application/x-www-form-urlencoded; charset=utf-8',
      'x-requested-with': 'XMLHttpRequest',
    },
  });
};

type DownloadableCheck = {
  data: {
    access: boolean;
    allowedMedia: string;
    restrictedMedia: string;
  };
};

type NewDownloadResponse = {
  data: {
    download_id: string;
    signed_url: string;
  };
};
